export default "__VITE_ASSET__ojk7ejKT__"